import DownloadIcon from '@mui/icons-material/Download';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Pagination,
  Typography,
} from '@mui/material';
import ContainerPainel from 'components/container_painel';
import CardViewTermoAdesao from 'components/shared/card_termo_de_adesao_view';
import FiltroTermosAdesao from 'components/termos/FiltroTermosAdesao';
import React, { useEffect } from 'react';
import useTermsStore from 'stores/terms/terms.store';
import useTermOfAdhesion from './use_term_of_adhesion';
import { getAllAgreementTerms } from 'api/agreement-term/agreement-term.api';
import { usePermissions, ModuleEnum, PermissionType } from 'contexts/auth/permission_context';
import { ROUTES } from 'routes/constants';

const TermOfAdhesion: React.FC = () => {
  const {
    navigate,
    selectedUsers,
    selectAllChecked,
    handleSelectAll,
    handleSelectTerm,
    anchorEl,
    open,
    handleClick,
    handleClose,
    handleDownloadSelected,
    totalCount,
  } = useTermOfAdhesion();

  const { terms, loading, orderBy, filterStatus, filterCity, take, page } =
    useTermsStore();
  const { setLoading, setTerms, setTotalCount, setPage } = useTermsStore();
  const { hasPermission } = usePermissions();

  useEffect(() => {
    if (!hasPermission(ModuleEnum.ADHESION_TERM, PermissionType.LIST)) {
      alert('Você não tem permissão para acessar esta página.');
      navigate(ROUTES.HOME);
    }
  }, []); 
  
  const fetchTerms = async () => {
    setLoading(true);
    try {
      const response = await getAllAgreementTerms({
        page: String(page),
        take: String(take),
        sortBy: 'created_at',
        orderBy,
        withDeleted: false,
        status: filterStatus ?? undefined,
        city: filterCity ?? undefined,
        //signatureAt,
        //dueAt,
      });

      setTerms(response.data);
      setTotalCount(response.info.count);
    } catch (error) {
      console.error('Erro ao buscar termos de adesão:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTerms();
  }, [orderBy, page, take]);

  return (
    // adicionar o context

    <ContainerPainel
      pagina='Gerenciar Termos de Adesão Municipal'
      showBackButton={true}
    >
      {/* Barra Superior */}
      <FiltroTermosAdesao />

      {/* Seleção */}
      <Box sx={{ backgroundColor: '#0048B6', width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            paddingX: '40px',
            maxWidth: '1200px',
            margin: '0 auto',
            height: '50px',
          }}
        >
          <Checkbox
            sx={{ color: '#FFFFFF' }}
            checked={selectAllChecked}
            onChange={handleSelectAll}
          />
          <Typography
            sx={{ color: '#FFFFFF', fontSize: '18px', marginRight: '18px' }}
          >
            Selecionar todos | {selectedUsers.length} de {terms.length}{' '}
            selecionado(s)
          </Typography>
          {/* Botão de Download - Só aparece se tiver pelo menos 1 item selecionado */}
          {selectedUsers.length > 0 && hasPermission(ModuleEnum.ADHESION_TERM, PermissionType.READ) && (
            <Button
              variant='contained'
              startIcon={<DownloadIcon />}
              onClick={() => handleDownloadSelected()}
              sx={{
                backgroundColor: 'transparent',
                color: '#FFFFFF',
                border: '1px solid #FFFFFF',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                '&:hover': {
                  backgroundColor: '#E3F2FD',
                  color: '#0048B6',
                },
              }}
            >
              Baixar Termo(s) Selecionado(s)
            </Button>
          )}
        </Box>
      </Box>

      {/* Lista de Termos */}
      <Box sx={{ padding: '20px 40px', maxWidth: '1200px', margin: '0 auto' }}>
        {loading ? (
          <CircularProgress sx={{ display: 'block', margin: 'auto' }} />
        ) : terms.length === 0 ? (
          <Typography sx={{ textAlign: 'center', marginTop: '20px' }}>
            Nenhum termo encontrado.
          </Typography>
        ) : (
          terms.map((term, index) => {
            console.log('term', term);
            return (
              <CardViewTermoAdesao
                key={index}
                term={term}
                selectedUsers={selectedUsers}
                handleSelectTerm={handleSelectTerm}
                handleClick={handleClick}
                handleClose={handleClose}
                open={open}
                anchorEl={anchorEl}
                navigate={navigate}
              />
            );
          })
        )}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginY: 4 }}>
        <Pagination
          count={Math.ceil(totalCount / take)}
          page={page}
          color='primary'
          onChange={(_, newPage) => setPage(newPage)}
        />
      </Box>
    </ContainerPainel>
  );
};

export default TermOfAdhesion;
